import { GRID_PAGE_SIZE } from '../../constants';
import { ColDef, GridOptions } from 'ag-grid-community';

export const BASE_GRID_OPTIONS: GridOptions = {
  sideBar: false,
  animateRows: false,
  suppressColumnMoveAnimation: false,
  suppressColumnVirtualisation: process.env.NODE_ENV === 'test',
  enableBrowserTooltips: true,
  blockLoadDebounceMillis: 300,
  // The app attaches custom properties to colDefs (e.g. `isLeftAlign`); keep
  // ag-grid's property-name validation off so they don't log warnings.
  // Deprecated since v33 (AG Grid wants custom data in `context`) but still
  // honoured; setupTests filters the deprecation notice.
  suppressPropertyNamesCheck: true,
  // No grid uses ag-grid pagination; hide the pagination panel entirely so it
  // adds no stray (otherwise always-rendered, hidden) DOM.
  paginationPanels: [],
};

const buildGridOptions = ({
  columnDefs = [],
  rowHeight,
  rowModelType = 'serverSide',
  suppressColumnVirtualisation,
}: {
  columnDefs?: ColDef[];
  rowModelType?: 'serverSide' | 'clientSide';
  rowHeight: number; // See: RowHeightProvider
  suppressColumnVirtualisation?: boolean;
}): GridOptions => ({
  columnDefs,
  rowModelType,
  rowHeight,
  cacheBlockSize:
    rowModelType && rowModelType === 'clientSide' ? undefined : GRID_PAGE_SIZE,
  ...BASE_GRID_OPTIONS,
  columnTypes: {
    dimension: {
      enableRowGroup: true,
    },
    valueColumn: {
      aggFunc: 'sum',
      enableValue: true,
      cellClass: 'number',
      allowedAggFuncs: ['avg', 'sum', 'min', 'max'],
    },
  },
  defaultColDef: {
    sortable: true,
    sortingOrder: ['desc', 'asc', null],
    cellRenderer: 'normalCellRenderer',
    cellRendererParams: {
      isLeftAlign: true,
    },
    wrapHeaderText: true,
    autoHeaderHeight: false,
    resizable: true,
    headerComponentParams: {
      template:
        '<div class="ag-cell-label-container" role="presentation">' +
        '  <span data-ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
        '  <div data-ref="eLabel" class="ag-header-cell-label" role="presentation">' +
        '    <span data-ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
        '    <span data-ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
        '    <span data-ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
        '    <span data-ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
        '    <span data-ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
        '    <span data-ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
        '  </div>' +
        '</div>',
    },
  },
  suppressColumnVirtualisation:
    suppressColumnVirtualisation || process.env.NODE_ENV === 'test',
  singleClickEdit: true,
  stopEditingWhenCellsLoseFocus: true,
});

export default buildGridOptions;
